import Alert from '@mui/material/Alert';
import { Trans } from 'react-i18next';
import { useSummaryAlert } from '../../../hooks/useSummaryAlert';

export const SummaryAlert = () => {
  const showSummaryAlert = useSummaryAlert();
  if (!showSummaryAlert) {
    return null;
  }
  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      <Trans i18nKey="summaryMultipleProviderAlert">
        Using <strong>AND</strong> to combine segments from multiple data providers may increase data fees and lead to
        higher bid floors for your deals. For details please refer to the <strong>Data Partner Pricing Guide</strong>.
      </Trans>
    </Alert>
  );
};
